






import { Component, Vue } from 'vue-property-decorator'
import WorkRecorderChart from '@/components/work_recorder/WorkRecorderChart.vue'

@Component({
  components: { WorkRecorderChart },
  computed: {},
})
export default class WorkRecorder extends Vue {}
